/**
 * @voltxampere/ui — Alligator clip pair (Sprint 50-8)
 *
 * Pair of insulated alligator (crocodile) clips — standard test
 * lead variant for breadboard prototyping, multimeter probes,
 * power supply jumpers. Red + black insulator pair (positive +
 * ground convention).
 *
 * Modeled as a passive wire pair (zero series resistance, zero
 * voltage drop).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`
 * (no MNA contribution).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const connectorAlligatorClips = {
    id: "alligator-clips",
    nameTr: "Krokodil Pens Çifti (kırmızı + siyah)",
    nameEn: "Alligator Clip Pair (red + black)",
    shortcut: "J",
    category: "connector",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "J",
    defaultValue: "Test Leads",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 0,
        busType: "test-lead",
        pairCount: 2,
        insulation: "red+black PVC",
        typicalLengthCm: 50,
        typicalCurrentRatingA: 5,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=connector-alligator-clips.js.map